import { el } from 'redom';

import InputRow from 'generics/components/text-input-row/row';

import RemindersInput from './input';

class RemindersSection {

  constructor(configuration) {

    this.event = configuration.event;

    this.input = new RemindersInput({
      reminders: this.event.reminders,
      onChange: configuration.onChange
    });

    this.el = el('#calendar-activity-reminders-section-main', [
      new InputRow({
        label: 'Reminders',
        input: this.input
      })
    ]);

  }

  setValue(reminders) {

    this.input.setValue(reminders);

  }

  getValue() {

    return this.input.getValue();

  }

  setErrors() {}

  clearErrors() {}

}

export default RemindersSection;